"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var icons_1 = require("@ant-design/icons");
var antd_1 = require("antd");
var braft_utils_1 = require("braft-utils");
var react_1 = __importDefault(require("react"));
var ControlBarButton_1 = __importDefault(require("./ControlBarButton"));
var transifex_1 = require("../../../transifex");
var blocks = [
    {
        block: "ordered-list-item",
        icon: react_1.default.createElement(icons_1.OrderedListOutlined, null),
        tooltip: transifex_1.TX_NUMBER_LIST,
    },
    {
        block: "unordered-list-item",
        icon: react_1.default.createElement(icons_1.UnorderedListOutlined, null),
        tooltip: transifex_1.TX_BULLET_LIST,
    },
];
var Block = function (_a) {
    var editorState = _a.editorState, toggleBlock = _a.toggleBlock;
    return (react_1.default.createElement(antd_1.Row, { gutter: 8 }, blocks.map(function (_a) {
        var icon = _a.icon, tooltip = _a.tooltip, block = _a.block;
        return (react_1.default.createElement(antd_1.Col, null,
            react_1.default.createElement(ControlBarButton_1.default, { active: braft_utils_1.ContentUtils.getSelectionBlockType(editorState) === block, onClick: function () { return toggleBlock(block); }, tooltip: tooltip, icon: icon })));
    })));
};
exports.default = Block;
